import { LegacyButton } from '../../atoms/legacy/LegacyButton';

export type EnableAutoMatchingProps = {
  instance: string;
};

/**
 * @deprecated This component was migrated from Preact and should not be used or refactored.
 * It does not comply with our current architectural patterns (compound components, proper separation of concerns, etc.).
 * These legacy components will be migrated in due course.
 */
export function EnableAutoMatching({ instance }: EnableAutoMatchingProps) {
  const handleClick = () => {
    const confirmed = confirm(
      `Cela rétablira toutes les configurations des rapprochements automatiques sur les prospects et annonces de toute l'instance (les configurations au niveau "Paramètres logiciel" ne seront pas impactées), êtes-vous sûr ? En cas de besoin + spécifique, merci de faire un ticket.`,
    );

    if (!confirmed) {
      alert('Action annulée.');
      return;
    }

    fetch(`/HektorBox/enableRapprochementAutomatiqueByInstance?instance=${instance}`)
      .then((res) => res.json())
      .then((res) =>
        res?.result === 'OK'
          ? alert('Configuration rétablie.')
          : alert(res?.result || 'Erreur inconnue'),
      )
      .catch((err) => alert(err.toString()));
  };

  return (
    <LegacyButton onClick={handleClick}>
      Activer en masse les rapprochements automatiques
    </LegacyButton>
  );
}
